/**
 * @generated SignedSource<<3a36e0163c59417061af0c8efda82498>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesAssociatesOrderFormsWhere = {
  code?: SalesAssociatesOrderFormsWhereCodeOperator | null;
  orderFormId?: SalesAssociatesOrderFormsWhereOrderFormIdOperator | null;
};
export type SalesAssociatesOrderFormsWhereCodeOperator = {
  eq?: string | null;
};
export type SalesAssociatesOrderFormsWhereOrderFormIdOperator = {
  eq?: string | null;
};
export type useSalesAssociatesOrderFormQuery$variables = {
  where?: SalesAssociatesOrderFormsWhere | null;
};
export type useSalesAssociatesOrderFormQuery$data = {
  readonly salesAssociatesOrderForms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly updatedIn: any | null;
        readonly cartTotal: string | null;
        readonly code: string | null;
        readonly customerIdentification: string | null;
        readonly customerName: string | null;
        readonly numberOfItems: number | null;
        readonly orderFormId: string | null;
        readonly orderGroupId: string | null;
        readonly status: string | null;
        readonly vendor: string | null;
        readonly vendorLinked: {
          readonly id: string | null;
          readonly name: string | null;
          readonly user: string | null;
          readonly code: string | null;
          readonly store: string | null;
          readonly storeLinked: {
            readonly id: string | null;
            readonly country: string | null;
            readonly name: string | null;
            readonly tradePolicy: string | null;
            readonly address: string | null;
            readonly number: string | null;
            readonly neighborhood: string | null;
            readonly city: string | null;
            readonly state: string | null;
            readonly postalCode: string | null;
            readonly mobileNumber: string | null;
            readonly pickupPoint: string | null;
            readonly franchiseAccount: string | null;
            readonly inactivatedAt: string | null;
          } | null;
        } | null;
        readonly createdIn: string | null;
      };
    }>;
  };
};
export type useSalesAssociatesOrderFormQuery = {
  variables: useSalesAssociatesOrderFormQuery$variables;
  response: useSalesAssociatesOrderFormQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "SalesAssociateOrderFormConnection",
    "kind": "LinkedField",
    "name": "salesAssociatesOrderForms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SalesAssociateOrderFormEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociateOrderForm",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cartTotal",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerIdentification",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfItems",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orderFormId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orderGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vendor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesAssociateOrderFormVendorLinked",
                "kind": "LinkedField",
                "name": "vendorLinked",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "user",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "store",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesAssociateOrderFormVendorLinkedStoreLinked",
                    "kind": "LinkedField",
                    "name": "storeLinked",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tradePolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "number",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "neighborhood",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pickupPoint",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "franchiseAccount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "inactivatedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdIn",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSalesAssociatesOrderFormQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSalesAssociatesOrderFormQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "590ecf27df14968bbe42db4662ee055d",
    "id": null,
    "metadata": {},
    "name": "useSalesAssociatesOrderFormQuery",
    "operationKind": "query",
    "text": "query useSalesAssociatesOrderFormQuery(\n  $where: SalesAssociatesOrderFormsWhere\n) {\n  salesAssociatesOrderForms(where: $where) {\n    edges {\n      node {\n        id\n        updatedIn\n        cartTotal\n        code\n        customerIdentification\n        customerName\n        numberOfItems\n        orderFormId\n        orderGroupId\n        status\n        vendor\n        vendorLinked {\n          id\n          name\n          user\n          code\n          store\n          storeLinked {\n            id\n            country\n            name\n            tradePolicy\n            address\n            number\n            neighborhood\n            city\n            state\n            postalCode\n            mobileNumber\n            pickupPoint\n            franchiseAccount\n            inactivatedAt\n          }\n        }\n        createdIn\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ecb6edbfafe743267a1e5b24d226c1c8";

export default node;
